import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

/**
 * Creates 2x2x2 brick gameobjects.
 * @param {HYPERCUBEJS.Material} [$material] The material to add.
 * @returns {HYPERCUBEJS.Node}
 */
function gameobjectbrick2x2x2($material = HYPERCUBEJS.DEFAULTS.material()) {

    const brick2x2x2 = new HYPERCUBEJS.Node('brick2x2x2');
    const meshbrick2x2x2 = new HYPERCUBEJS.MeshBox('meshbrick2x2x2', [2, 2, 2]);

    meshbrick2x2x2.setmaterial($material);
    brick2x2x2.addmesh(meshbrick2x2x2);

    brick2x2x2.setcomponent('collideraabb', {

        'type': 'static',

        'min': [-1, -1, -1],
        'max': [1, 1, 1]
    });

    return brick2x2x2;
}

export {

    gameobjectbrick2x2x2
};

export default gameobjectbrick2x2x2;
